import { useRouteLoaderData } from 'react-router'

import { ShubOrgInfo } from '~/shared/types/org'

export const useShubOrgInfo = (): ShubOrgInfo => {
  const rootAdminLoaderData = useRouteLoaderData<ShubOrgInfo>('routes/sp-admin/_index')
  const consumerLoaderData = useRouteLoaderData<ShubOrgInfo>('routes/_docs/_index')
  const offlineStatusLoaderData = useRouteLoaderData<ShubOrgInfo>('routes/sp-portal/_index')
  const catalogLoaderData = useRouteLoaderData<ShubOrgInfo>('routes/_home/_index')
  const loaderData = rootAdminLoaderData || consumerLoaderData || offlineStatusLoaderData || catalogLoaderData
  const organizationRole = loaderData?.organizationRole
  const highestRole = loaderData?.highestRole
  const swaggerhubOrgName = loaderData?.swaggerhubOrgName || ''
  const swaggerhubOrgDisplayName = loaderData?.swaggerhubOrgDisplayName || ''
  const swaggerhubOrgId = loaderData?.swaggerhubOrgId || ''

  return { organizationRole, swaggerhubOrgName, swaggerhubOrgDisplayName, highestRole, swaggerhubOrgId }
}
